// Landing 2026 v2 — JoinKids Idiomas
// Tipografia Baloo 2 + Nunito, ícones SVG próprios (sem emoji), imagem/vídeo
// dos mascotes primeiro no celular, foco em conversão (teste grátis).
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Pagina, Barra, BarraLogo, BarraEntrar,
  Hero, HeroConteudo, HeroTexto, HeroChip, HeroTitulo, HeroSub, HeroImagem, HeroVideo,
  BotaoCTA, CTALegenda, LinkSuave,
  Confianca, ConfiancaItem,
  Secao, SecaoMiolo, SecaoTitulo, SecaoSub,
  Passos, Passo, PassoNumero, PassoTitulo, PassoTexto,
  Vitrine, VitrineCard, VitrineImagem, VitrineTitulo, VitrineTexto,
  Familia, FamiliaImagem, FamiliaLista,
  Numeros, Numero,
  PlanosGrade, PlanoCard, PlanoSelo, PlanoNome, PlanoPreco, PlanoAncora,
  PlanoRiscado, PlanoLista,
  FaqLista, FaqItem,
  FinalWrap, FinalImagem,
  Rodape, RodapeLogo, RodapeLinha, RodapeMini,
} from './styled';
import {
  IcEscudo, IcCadeado, IcCoracaoCruz, IcFamilia, IcCheck, IcSeta,
} from './Icones';

// ⚠️ Só deixe true quando o período grátis estiver ATIVO na cobrança (Cielo).
const TESTE_GRATIS_ATIVO = true;

const CTA_TEXTO = TESTE_GRATIS_ATIVO ? 'Experimentar 7 dias grátis' : 'Começar agora';

// Mídia do hero: vídeo animado no computador (efeito "uau"), imagem leve no
// celular (economia de dados + carrega instantâneo).
function HeroMidia() {
  const [comVideo, setComVideo] = useState(false);
  useEffect(() => {
    if (window.matchMedia && window.matchMedia('(min-width: 901px)').matches) {
      setComVideo(true);
    }
  }, []);
  if (comVideo) {
    return (
      <HeroVideo
        src="/videos/hero_mascotes.mp4"
        poster="/images/hero_jogo.jpg"
        autoPlay muted loop playsInline
        aria-label="Lulu e Nando acenando ao lado do mapa de fases do jogo"
        onError={() => setComVideo(false)}
      />
    );
  }
  return (
    <HeroImagem
      src="/images/hero_jogo.jpg"
      alt="Lulu e Nando mostrando o mapa de fases do jogo no celular"
    />
  );
}

export default function LandpageNova() {
  const history = useHistory();
  const irPlanos = () => history.push('/planos');
  const irLogin = () => history.push('/login');
  const verComoFunciona = () => {
    const el = document.getElementById('como-funciona');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Pagina>
      {/* Barra do topo */}
      <Barra>
        <BarraLogo src="/icons/logo_joinkids_idiomas.png" alt="JoinKids Idiomas" />
        <BarraEntrar onClick={irLogin}>Entrar</BarraEntrar>
      </Barra>

      {/* HERO — no celular a mídia vem primeiro (column-reverse no styled) */}
      <Hero>
        <HeroConteudo>
          <HeroTexto>
            <HeroChip><IcEscudo tam={18} /> Sem anúncios · 100% seguro · Valores cristãos</HeroChip>
            <HeroTitulo>Transforme o tempo de tela do seu filho em inglês e espanhol de verdade</HeroTitulo>
            <HeroSub>
              Jogos com as vozes da Lulu e do Nando, figurinhas para colecionar e um
              chat seguro que ensina idiomas e valores — com relatório completo para você.
            </HeroSub>
            <BotaoCTA onClick={irPlanos}>{CTA_TEXTO} <IcSeta /></BotaoCTA>
            <CTALegenda>
              {TESTE_GRATIS_ATIVO ? 'Depois, menos de R$ 1,17 por dia · Cancele quando quiser' : 'Menos de R$ 1,17 por dia · Cancele quando quiser'}
            </CTALegenda>
            <div><LinkSuave onClick={verComoFunciona}>Ver como funciona ↓</LinkSuave></div>
          </HeroTexto>
          <HeroMidia />
        </HeroConteudo>
      </Hero>

      {/* BARRA DE CONFIANÇA */}
      <Confianca>
        <ConfiancaItem><IcEscudo /> Sem anúncios</ConfiancaItem>
        <ConfiancaItem><IcCadeado /> Dados protegidos</ConfiancaItem>
        <ConfiancaItem><IcCoracaoCruz /> Valores cristãos</ConfiancaItem>
        <ConfiancaItem><IcFamilia /> Pais acompanham tudo</ConfiancaItem>
      </Confianca>

      {/* COMO FUNCIONA */}
      <Secao id="como-funciona" fundo="#fff">
        <SecaoMiolo>
          <SecaoTitulo>Como funciona?</SecaoTitulo>
          <SecaoSub>Simples para você, mágico para o seu filho.</SecaoSub>
          <Passos>
            <Passo>
              <PassoNumero cor="#4FA3E3">1</PassoNumero>
              <PassoTitulo>Escolha o idioma</PassoTitulo>
              <PassoTexto>Inglês ou espanhol — dá para alternar quando quiser, os dois estão incluídos.</PassoTexto>
            </Passo>
            <Passo>
              <PassoNumero cor="#F2549D">2</PassoNumero>
              <PassoTitulo>Jogue com a Lulu e o Nando</PassoTitulo>
              <PassoTexto>Mundos de jogos com voz, figurinhas, missões e um chat que conversa de verdade.</PassoTexto>
            </Passo>
            <Passo>
              <PassoNumero cor="#2FA95C">3</PassoNumero>
              <PassoTitulo>Acompanhe o progresso</PassoTitulo>
              <PassoTexto>A Área dos Pais mostra estrelas, palavras aprendidas e até o clima emocional das conversas.</PassoTexto>
            </Passo>
          </Passos>
        </SecaoMiolo>
      </Secao>

      {/* VITRINE */}
      <Secao fundo="#FFF8EF">
        <SecaoMiolo>
          <SecaoTitulo>Muito mais que um app: uma aventura completa</SecaoTitulo>
          <SecaoSub>Tudo isso incluído, sem anúncios e sem compras escondidas:</SecaoSub>
          <Vitrine>
            <VitrineCard>
              <VitrineImagem src="/images/modo_atividades.png" alt="Mapa de fases com troféu" />
              <VitrineTitulo>10 Mundos de Jogos</VitrineTitulo>
              <VitrineTexto>Animais, números, família, sentimentos... 120 palavras por idioma, em fases divertidas.</VitrineTexto>
            </VitrineCard>
            <VitrineCard>
              <VitrineImagem src="/atividades/figurinhas/lulu_oi.png" alt="Figurinha da Lulu acenando" />
              <VitrineTitulo>Mascotes que Falam</VitrineTitulo>
              <VitrineTexto>A Lulu e o Nando pronunciam cada palavra e explicam cada jogo com as próprias vozes.</VitrineTexto>
            </VitrineCard>
            <VitrineCard>
              <VitrineImagem src="/atividades/figurinhas/dupla_festa.png" alt="Figurinha rara da Lulu e do Nando em festa" />
              <VitrineTitulo>Álbum de Figurinhas</VitrineTitulo>
              <VitrineTexto>Mais de 30 figurinhas para colecionar: jogando, cumprindo missões e abrindo pacotes.</VitrineTexto>
            </VitrineCard>
            <VitrineCard>
              <VitrineImagem src="/atividades/figurinhas/lulu_campea.png" alt="Figurinha da Lulu campeã" />
              <VitrineTitulo>Meta Diária e Sequência</VitrineTitulo>
              <VitrineTexto>Uma fase por dia, comemoração ao cumprir e sequência de dias que motiva a voltar.</VitrineTexto>
            </VitrineCard>
            <VitrineCard>
              <VitrineImagem src="/images/card_lulu_idioma_LP.png" alt="Tela do chat com a Lulu" />
              <VitrineTitulo>Chat que Ensina</VitrineTitulo>
              <VitrineTexto>Conversas por texto que se adaptam ao nível do seu filho — como um amiguinho professor.</VitrineTexto>
            </VitrineCard>
            <VitrineCard>
              <VitrineImagem src="/atividades/figurinhas/nando_lupa.png" alt="Figurinha do Nando com lupa" />
              <VitrineTitulo>Área dos Pais</VitrineTitulo>
              <VitrineTexto>Relatório por filho: progresso, palavras aprendidas e momentos que pedem seu carinho.</VitrineTexto>
            </VitrineCard>
          </Vitrine>
        </SecaoMiolo>
      </Secao>

      {/* FAMÍLIA / VALORES */}
      <Secao fundo="#fff">
        <SecaoMiolo>
          <SecaoTitulo>Feito para a sua família</SecaoTitulo>
          <Familia>
            <FamiliaImagem src="/images/familia_biblia.jpg" alt="Lulu e Nando lendo a Bíblia juntos" />
            <div>
              <SecaoSub style={{ margin: 0, textAlign: 'inherit' }}>
                Aqui, aprender idiomas caminha junto com aquilo que a sua família valoriza:
              </SecaoSub>
              <FamiliaLista>
                <li><IcCoracaoCruz tam={20} /> <span><b>Chat Bíblico</b> para conversar sobre histórias e valores da fé</span></li>
                <li><IcCheck /> <span>Mundos que ensinam a <b>orar, ajudar e compartilhar</b> (em inglês e espanhol!)</span></li>
                <li><IcEscudo /> <span>Ambiente fechado: <b>sem estranhos, sem anúncios</b>, sem conteúdo impróprio</span></li>
                <li><IcFamilia tam={20} /> <span>Em temas delicados, os personagens orientam a criança a <b>procurar um adulto de confiança</b></span></li>
              </FamiliaLista>
            </div>
          </Familia>
        </SecaoMiolo>
      </Secao>

      {/* NÚMEROS */}
      <Secao fundo="#FFF8EF">
        <SecaoMiolo>
          <Numeros>
            <Numero cor="#7C4DD8"><b>10</b><span>mundos de jogos</span></Numero>
            <Numero cor="#F2549D"><b>240</b><span>áudios com vozes reais</span></Numero>
            <Numero cor="#4FA3E3"><b>2</b><span>idiomas incluídos</span></Numero>
            <Numero cor="#2FA95C"><b>30+</b><span>figurinhas para colecionar</span></Numero>
          </Numeros>
        </SecaoMiolo>
      </Secao>

      {/* PLANOS */}
      <Secao fundo="#fff">
        <SecaoMiolo>
          <SecaoTitulo>Um plano simples, tudo incluído</SecaoTitulo>
          <SecaoSub>
            {TESTE_GRATIS_ATIVO
              ? 'Experimente 7 dias grátis. Gostou? Continue por menos que um cafezinho por dia.'
              : 'Menos que um cafezinho por dia, com tudo liberado.'}
          </SecaoSub>
          <PlanosGrade>
            <PlanoCard destaque>
              <PlanoSelo>{TESTE_GRATIS_ATIVO ? '7 DIAS GRÁTIS' : 'MAIS POPULAR'}</PlanoSelo>
              <PlanoNome>Mensal</PlanoNome>
              <PlanoPreco>R$ 34,90<small>/mês</small></PlanoPreco>
              <PlanoAncora>menos de R$ 1,17 por dia</PlanoAncora>
              <PlanoLista>
                <li><IcCheck /> <span><b>Até 3 filhos</b> em uma assinatura</span></li>
                <li><IcCheck /> <span>10 mundos de jogos com voz</span></li>
                <li><IcCheck /> <span>Inglês E espanhol</span></li>
                <li><IcCheck /> <span>Chat com a Lulu e o Nando</span></li>
                <li><IcCheck /> <span>Chat Bíblico</span></li>
                <li><IcCheck /> <span>Álbum de figurinhas e missões</span></li>
                <li><IcCheck /> <span>Área dos Pais com relatório</span></li>
              </PlanoLista>
              <BotaoCTA onClick={irPlanos} style={{ width: '100%' }}>{CTA_TEXTO}</BotaoCTA>
            </PlanoCard>
            <PlanoCard>
              <PlanoSelo cor="#4FA3E3">ECONOMIZE 22%</PlanoSelo>
              <PlanoNome>Anual</PlanoNome>
              <PlanoRiscado>R$ 418,80</PlanoRiscado>
              <PlanoPreco>R$ 322,90<small>/ano</small></PlanoPreco>
              <PlanoAncora>sai por R$ 26,90 por mês</PlanoAncora>
              <PlanoLista>
                <li><IcCheck cor="#4FA3E3" /> <span>Tudo do plano mensal</span></li>
                <li><IcCheck cor="#4FA3E3" /> <span>12 meses pelo preço de 9 meses</span></li>
                <li><IcCheck cor="#4FA3E3" /> <span>Preço travado por 1 ano</span></li>
              </PlanoLista>
              <BotaoCTA onClick={irPlanos} style={{ width: '100%', background: '#4FA3E3', boxShadow: '0 6px 0 #2f7cb3, 0 10px 22px rgba(79,163,227,0.35)' }}>
                Escolher o Anual
              </BotaoCTA>
            </PlanoCard>
          </PlanosGrade>
          <CTALegenda style={{ marginTop: 16 }}>Cancele quando quiser, direto na plataforma. Sem multa, sem pegadinha.</CTALegenda>
        </SecaoMiolo>
      </Secao>

      {/* FAQ */}
      <Secao fundo="#FFF8EF">
        <SecaoMiolo>
          <SecaoTitulo>Perguntas de mãe (e de pai também!)</SecaoTitulo>
          <SecaoSub>As dúvidas que mais escutamos:</SecaoSub>
          <FaqLista>
            <FaqItem>
              <summary>Para qual idade é indicado?</summary>
              <p>Para crianças que já sabem ler ou estão aprendendo (por volta de 6 a 12 anos). Os jogos falam cada palavra em voz alta, o que ajuda muito quem ainda está começando a ler.</p>
            </FaqItem>
            <FaqItem>
              <summary>É seguro para o meu filho?</summary>
              <p>Sim. Não há anúncios nem contato com estranhos: seu filho interage apenas com os personagens. E em temas delicados, a Lulu e o Nando acolhem e orientam a criança a conversar com um adulto de confiança — e você fica sabendo pela Área dos Pais.</p>
            </FaqItem>
            <FaqItem>
              <summary>Funciona no celular?</summary>
              <p>Sim! Funciona direto no navegador do celular, tablet ou computador — sem precisar instalar nada.</p>
            </FaqItem>
            <FaqItem>
              <summary>Tenho mais de um filho. Preciso de mais de uma conta?</summary>
              <p>Não! Uma única assinatura permite criar até <b>3 perfis</b> (um para cada filho), cada um com seu próprio progresso, figurinhas, nível e relatório na Área dos Pais.</p>
            </FaqItem>
            <FaqItem>
              <summary>Como acompanho o que meu filho está aprendendo?</summary>
              <p>Na Área dos Pais você vê, por filho: mundos completados, estrelas, palavras aprendidas, sequência de dias e até o clima emocional das conversas.</p>
            </FaqItem>
            <FaqItem>
              <summary>E se eu quiser cancelar?</summary>
              <p>Você cancela quando quiser, direto na própria plataforma, sem multa e sem burocracia.</p>
            </FaqItem>
          </FaqLista>
        </SecaoMiolo>
      </Secao>

      {/* CTA FINAL */}
      <Secao fundo="#fff">
        <FinalWrap>
          <FinalImagem src="/images/hero_festa.jpg" alt="Lulu e Nando comemorando entre estrelas e figurinhas" />
          <SecaoTitulo>Vamos começar essa aventura?</SecaoTitulo>
          <SecaoSub>Seu filho aprendendo inglês e espanhol com alegria — e você acompanhando cada passo.</SecaoSub>
          <BotaoCTA onClick={irPlanos}>{CTA_TEXTO} <IcSeta /></BotaoCTA>
          {TESTE_GRATIS_ATIVO && <CTALegenda>Sem compromisso: cancele dentro dos 7 dias e não pague nada.</CTALegenda>}
        </FinalWrap>
      </Secao>

      {/* RODAPÉ */}
      <Rodape>
        <RodapeLogo src="/icons/logo_joinkids_idiomas_v_claro.png" alt="JoinKids Idiomas" />
        <RodapeLinha>WhatsApp: (92) 98216-8732 · e-mail: atendimento@joinkids.com.br</RodapeLinha>
        <RodapeLinha><a href="/privacity-police">Política de Privacidade</a></RodapeLinha>
        <RodapeMini>© {new Date().getFullYear()} JoinKids Idiomas. Feito com 💛 para famílias.</RodapeMini>
      </Rodape>
    </Pagina>
  );
}
